import React from 'react';
import { connect } from 'react-redux';
import { apiUrl } from 'local_config';
import EngineeringBalastActionButton from './engineeringBalastActionButton';

type Props = {
  engineeringBallastMaps: engineeringBallastMapsState,
  projectId: string,
  engineeringProjectDocuments: engineeringProjectDocumentsState,
  arrayName?: string,
  displayName?: string,
  productId?: number | string,
};

class OpenMapInNewTabButton extends React.Component<Props> {
  openInNewTab = () => {
    const { engineeringBallastMaps: { generatedArrayId, generatedLayoutType }, projectId, engineeringProjectDocuments: {units} } = this.props;
    window.open(`${location.protocol}//${apiUrl}api/v1/reports/${projectId}/layout/${generatedArrayId}/${generatedLayoutType}/${units}`);
  }

  openImageInNewTab = () => {
    const { engineeringBallastMaps: { generatedArrayId, generatedLayoutType }, projectId, engineeringProjectDocuments: {units}, arrayName, displayName, productId } = this.props;
    const imageUrl = `${location.protocol}//${apiUrl}api/v1/reports/${projectId}/layout/${generatedArrayId}/${generatedLayoutType}/${units}?name=${generateMapName(productId, projectId, arrayName, displayName)}.jpg` ;

    const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>${generateMapName(productId, projectId, arrayName, displayName)}</title>
          <style>
          html, body {
            width: 100%;
            height: 100%;
            margin: 0;
          }
          body {
            background: #111;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
          </style>
        </head>
        <body>
          <img src="${imageUrl}">
        </body>
        </html>
      `;

      const blob = new Blob([html], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      
      const viewerTab = window.open(url, '_blank');
      
      // Clean up when tab is closed
      const interval = setInterval(() => {
        if (viewerTab?.closed) {
          URL.revokeObjectURL(url);
          clearInterval(interval);
        }
      }, 1000);
      

  }

  render() {
    const { engineeringBallastMaps: { generated } } = this.props;

    if (generated) {
      return (
        <EngineeringBalastActionButton 
          tooltipLabel="Open image in new tab" 
          onClick={this.openImageInNewTab} 
          svgPath={require('assets/media/icons/icon_newtab.svg')}
        />
      );
    }

    return null;
  }
}

function generateMapName(
  productId,
  projectId,
  arrayName,
  displayName
){
 return [
   productId?.replace(/[\s_-]/g,'').toUpperCase(),
   projectId,
   displayName?.replace(/\s+/g,'-').toUpperCase(),
   arrayName
 ]
 .filter(Boolean)
 .join('_');
}

function mapStateToProps(appState: appState) {
  return {
    engineeringBallastMaps: appState.engineeringBallastMaps,
    engineeringProjectDocuments : appState.engineeringProjectDocuments
  };
}

export default connect(mapStateToProps)(OpenMapInNewTabButton);
